import { useState,useEffect, useRef } from "react"; 
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as RefreshIcon } from "../../assets/svg/refresh-icon.svg";
import { getValidateScanDataApi } from "../dock/dock-api";


 const ScanQRCodeModal = ({scanDataResult,onSuccess, onCancel }) => {
  
    const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
      width: "365px",
      height: "425px",
      textAlign: "center",
    },
  };
   const [isScannerActive, setIsScannerActive] = useState(true);
     const [displayMessage, setDisplayMessage] = useState(null);
 // const [scanDataResult, setScanDataResult] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [stopStream, setStopStream] = useState(false)

     const handleError = (err) => {
    console.error("Scan error:", err);
    /* setErrorMessage("No QR code detected. Try again."); */
  };
  const openModal = () => {

    console.log("open modal called");

    
    setStopStream(false)
    setIsScannerActive(true);
  };
  const restartScanner = () => {
    setDisplayMessage("Restarting scanner...")
    setIsScannerActive(false); // Unmount scanner
    setTimeout(() => setIsScannerActive(true), 100); // Remount scanner after a short delay
   // setScanDataResult(null); // Reset the scan result
    setErrorMessage(null); // Clear any error messages
  };

  const closeModal = () => {
    setStopStream(true)
    setIsScannerActive(false);
    onCancel()
  }

  const handleScan = (result) => {
    console.log('scan data........', result)
    if (result) {
      setDisplayMessage("Please wait...")
      setStopStream(true)
      setIsScannerActive(false);
      console.log('scan data........', result.text)
      validateScanData(result.text)
      
    }
  };
   const validateScanData = async (qrTag) => {   
              try {
                const response = await getValidateScanDataApi(qrTag);
                console.log(response.data)
                if (response.data.success === true) {
                  if(response.data.data.available_status===true){
                  scanDataResult(response.data.data)
                  closeModal()
                  }else{
                      setDisplayMessage("Dock not available")
                  }
                   
                  //setScanDataResult(response.data.data);                
                 
                }else{
                  setDisplayMessage(response.data.message)
                }
            return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            }; 
  return (<div style={modalStyle.overlay}>
                  <div style={modalStyle.modal}>
                    <div style={{ color: '#ffffff' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', }}>
                          <div style={{ fontSize: "16px", fontWeight: "700", color: '#1E1E1E' }}>Place the QR code inside the area</div>
                        </div>
      
                      </div>
      
                      <div >
                        <div style={{ width: '320px', height: '320px', textAlign: 'center' }}>
                          {isScannerActive ? (
                            <BarcodeScannerComponent className="qr-image-wrapper"
                              width={320}
                              height={320}
                              onUpdate={(err, result) => {
                                console.log('scan data........', result);
                                if (result) handleScan(result);
                                else handleError(err);
                              }}
                              style={{
                                width: '320px',
                                height: '320px',
                                borderRadius: '16px',
                                overflow: 'hidden', // optional, to keep corners clean
                              }}
                              stopStream={stopStream}
                            />
      
      
                          ) : (
                            <div style={{ width: '320px', height: '320px', color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>{displayMessage}</div>
                          )}
                          {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                        </div>
                        <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                          <SlotCloseIcon onClick={closeModal} style={{ cursor: "pointer", width: '48px', height: '48px' }} /> <RefreshIcon onClick={restartScanner} style={{ cursor: "pointer", width: '48px', height: '48px' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)
 }
 export default ScanQRCodeModal;